<template>
    <v-dialog v-model="dialog" max-width="500">
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                <v-icon>{{icons.plus}}</v-icon>
                Invoice
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Send Invoices to {{activegroup.name}}
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                                outlined
                                label="Quantity"
                                v-model="qty"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                outlined
                                label="Amount"
                                v-model="amount"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                outlined
                                label="Line item description"
                                v-model="description"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                outlined
                                label="Set a code for these"
                                v-model="code"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="Create()" :loading="loading">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "InvoiceToGroup",
    components: {},
    data() {
      return {
        dialog: false,
        qty:0,
        description: 'Description',
        amount: 0,
        loading: false,
        code: undefined
      }
    },
    computed: {
      ...mapState(['icons','activegroup'])
    },
    watch:{
      dialog(n){
        if(!n)this.Close()
      }
    },
    methods: {
      ...mapActions(['get', 'post']),
      Close() {
        this.dialog = false
        this.qty=0
        this.description='Description'
        this.amount=0
        this.loading=false
      },
      async Create(){
        let data = {
          description: this.description,
          qty: this.qty,
          amount: this.amount,
          includetext: this.includetext,
          groupkey: this.activegroup.sortkey,
          code: this.code
        }
        this.loading=true
        let r = await this.post({path:'api/invoicesend/sendtogroup',body:data})
        this.Close()
        this.$emit('createdInvoice',r);
        this.loading=false
        this.items=[];
        this.customer='';
      }
    }
  }
</script>

<style scoped>

</style>